import React from 'react'
import Heading from './Heading'
import { Grid } from '@mui/material'
import FullName from './FullName'
import DatePickers from './DatePicker'
import SingleChoice from './SingleChoice'
import DropDown from './DropDown'
import Phone from './Phone'
import Email from './Email'
import Address from './Address'
import ShortText from './ShortText'

const CollegeAdmissionForm = () => {


    const countryData = [
        "ایران ",
        "ایالات متحده آمریکا",
        "ژاپن",
        "آلمان",
        "کره جنوبی",
        "بریتانیا",
        "کانادا",
        "استرالیا",
        "فرانسه",
        "برزیل",
        "هند",
    ]



    const genderData = [
        {
            id: 1,
            label: "آقا",
            checked: false
        },
        {
            id: 2,
            label: "خانم",
            checked: false
        },
    ]


    
    const yesOrNo = [
        {
            id: 1,
            label: "بله",
            checked: false
        },
        {
            id: 2,
            label: "خیر",
            checked: false
        },
    ]



    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم پذیرش دانشگاه'} subHeader={''} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'}/>
                <DatePickers header={'تاریخ تولد'}/>
                <SingleChoice header={'جنسیت'} options={genderData}/>
                <DropDown header={'شهروند کدام کشور هستید؟'} options={countryData}/>
                <Phone header={'تلفن'}/>
                <Email header={'آدرس ایمیل'}/>
                <Address header={'آدرس پستی'}/>
                <FullName header={'تماس اضطراری'}/>
                <ShortText header={'نسبت'}/>
                <Email header={'ایمیل'}/>
                <Phone header={'شماره تلفن'}/>
                <SingleChoice header={'آیا به زبان‌های دیگری غیر از انگلیسی صحبت می‌کنید؟'} options={yesOrNo}/>
            </Grid>
        </Grid>
    )
}

export default CollegeAdmissionForm
